<div class="govuk-grid-row">
    <div class="govuk-grid-column-two-thirds">
        <div class="content flex">
            <h1 class="govuk-heading-xl page-title">
                {{'ACCOUNT_DORMANT_MESSAGE' | translate}}</h1>
            <div class="govuk-body-l">{{'ACCOUNT_DORMANT_MESSAGE' | translate}}.</div>
            <div class="govuk-body-l">{{'CONTACT_ADMIN_MESSAGE' | translate}}.</div>
        </div>
    </div>
</div>